import { useState } from 'react';

import { History } from 'lucide-react';

import Modal from '@/components/molecules/Modals/SettingsModal';
import { UploadsOverview } from '@/screens/Chronos/CaseEditor/Settings/components/UploadsOverview';

interface UploadHistoryChipProps {
  caseId: string;
}

const UploadHistoryChip = ({ caseId }: UploadHistoryChipProps) => {
  const [historyModalOpen, setHistoryModalOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => setHistoryModalOpen(true)}
        className="flex items-center gap-2 rounded-full border bg-gray-100 px-2 py-1 hover:cursor-pointer hover:bg-gray-200"
      >
        <History className="text-gray-700" size={14} />
        <span className="text-xs text-gray-700">Upload History</span>
      </div>

      <Modal
        title={
          <div className="flex items-center gap-2 text-lg font-semibold text-gray-900">
            <History className="text-gray-700" />
            Upload History
          </div>
        }
        size="large"
        isOpen={historyModalOpen}
        handleClose={() => setHistoryModalOpen(false)}
        content={
          <div className="flex min-h-96 flex-col p-6">
            <UploadsOverview caseId={caseId} />
          </div>
        }
      />
    </>
  );
};

export default UploadHistoryChip;
